// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"546419646c9f86092bd9","303":"1ce7e4e2fdc640a8f283","495":"d09ebd17017563cbc381"}[chunkId] + ".js";
};